import { executeRequest, Request } from '@jfs/network'

import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { isLocalHostUrl } from './fetchGroupByRiskAudit'

const responseParser = (data: any) => {
  return data
}

const exportAuditApi: any = (req, tokens: any, abortController: any) => {
  const config = sitConfig(tokens, abortController)

  const url = isLocalHostUrl
    ? 'http://localhost:8080/api/v1.0/risk/history/export'
    : getUrl(APIEndPoints.exportAuditHistory)
  const request: Request<{}> = {
    config: config,
    apiPath: url,
    method: 'POST',
    headers: { ...getHeaders(), ...(isLocalHostUrl && { appIDToken: '66', 'x-channel-id': '66' }) },
    responseType: 'arraybuffer',
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export const downloadExportAuditApi: any = (fileName: string, tokens: any, abortController: any) => {
  console.log('getAbortController download', abortController)
  const config = sitConfig(tokens, abortController)

  const url = isLocalHostUrl
    ? 'http://localhost:8080/api/v1.0/risk/history/export?fileName=' + fileName
    : getUrl(APIEndPoints.exportAuditHistory + '?fileName=' + fileName)
  const request: Request<{}> = {
    config: config,
    apiPath: url,
    method: 'GET',
    headers: { ...getHeaders(), ...(isLocalHostUrl && { appIDToken: '66', 'x-channel-id': '66' }) },
    responseType: 'arraybuffer',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { exportAuditApi }
